import { useRecoilValue } from 'recoil';

import Table from 'components/common/Table/Table';
import { timezoneState } from 'components/common/Managers/PreferencesManager.state';
import { DataCardTabsProps } from '../../types';
import {
  EndpointTabs,
  getDefaultEndpointCardTableOptions,
  TASKS_EMPTY_STATE,
} from './DVEndpointDetailsRenderer.consts';
import { getTasksHeaders } from './DVEndpointDetailsRenderer.utils';
import './DVEndpointDetailsTasks.scss';

export const DVEndpointDetailsRendererTasks = ({ initialData }: DataCardTabsProps): JSX.Element => {
  const tasksTableItem = initialData?.s1Endpoint?.tasks?.data || [];

  const timezone = useRecoilValue(timezoneState);

  return tasksTableItem.length > 0 ? (
    <Table
      headers={getTasksHeaders(timezone)}
      data={tasksTableItem}
      options={getDefaultEndpointCardTableOptions(EndpointTabs.tasks)}
    />
  ) : (
    <div className="Tasks__EmptyState">{TASKS_EMPTY_STATE}</div>
  );
};

export default DVEndpointDetailsRendererTasks;
